<template>
  <v-row v-if="kurumsalSevkiyat">
    <v-col cols="4">
      <div
        style="min-height: calc(50dvh - 24px); background-color: rgba(255, 180, 0, 0.25)"
        class="d-flex flex-column mb-6 pa-6 rounded-xl"
      >
        <div class="d-flex align-center mb-6">
          <v-avatar color="warning" size="48" class="me-4">
            <v-icon size="24" color="white">{{ icons.mdiTruck }}</v-icon>
          </v-avatar>
          <div class="text-h6 font-weight-bold warning--text">Sevkiyat Bilgilendirme</div>
        </div>
        <div class="flex-grow-1">
          <v-list color="transparent" class="pa-0" nav two-line>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon color="warning">{{ icons.mdiMinus }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle class="warning--text">
                  Anadolu Yakası Siparişleriniz
                </v-list-item-subtitle>
                <v-list-item-title>
                  <strong>{{ kurumsalSevkiyatYaziAnadolu }}</strong> günleri sevkedilir.
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-avatar>
                <v-icon color="warning">{{ icons.mdiMinus }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle class="warning--text">
                  Avrupa Yakası Siparişleriniz
                </v-list-item-subtitle>
                <v-list-item-title>
                  <strong>{{ kurumsalSevkiyatYaziAvrupa }}</strong> günleri sevkedilir.
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
        <div>
          <v-btn class="text-capitalize" color="warning" to="order-approval" x-large rounded block
            >Bekleyen Siparişler</v-btn
          >
        </div>
      </div>

      <v-card rounded="xl" flat min-height="calc(50dvh - 128px)"> </v-card>
    </v-col>
    <v-col cols="8">
      <v-card rounded="xl" height="calc(100dvh - 128px)" flat>
        <v-card-title class="grey">
          <v-avatar color="primary" size="48" class="me-4">
            <v-icon size="24" color="white">{{ icons.mdiOrderNumericAscending }}</v-icon>
          </v-avatar>
          <div class="text-h6 font-weight-bold primary--text">Geçmiş Siparişler</div>
          <v-spacer />
          <v-btn rounded depressed class="text-capitalize" color="secondary" to="order-tracking"
            >Tüm Siparişler</v-btn
          >
        </v-card-title>

        <v-data-table
          :headers="siparisHeaders"
          :items="siparisItems"
          :items-per-page="5"
          hide-default-footer
          item-key="id"
          show-expand
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0">
              <v-list color="" class="pa-0">
                <div v-for="(el, index) in item.products" :key="`item-${index}`">
                  <v-list-item three-line>
                    <v-list-item-avatar
                      tile
                      :height="$vuetify.breakpoint.smAndUp ? 75 : 50"
                      :width="$vuetify.breakpoint.smAndUp ? 75 : 50"
                      color="white"
                      class="rounded-lg"
                    >
                      <v-avatar tile :height="60" :width="60">
                        <v-img
                          v-if="el.resim"
                          :src="$baseUrlAPI + '' + el.resim"
                          class="rounded-lg"
                        />
                        <v-icon v-else size="30" color="primary"> {{ icons.mdiCameraOff }}</v-icon>
                      </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="text-caption mb-1">
                          <v-chip
                            label
                            :small="$vuetify.breakpoint.smAndUp"
                            :x-small="!$vuetify.breakpoint.smAndUp"
                            color="secondary"
                            style="font-size: 10px"
                            >{{ el.prd_code }}</v-chip
                          >
                        </div>
                        <div class="text-caption text-sm-subtitle-2 white--text">
                          {{ el.baslik }}
                        </div>
                        <div class="text-caption" v-if="$vuetify.breakpoint.smAndUp">
                          {{ el.kategori_path.split(",")[1] }}
                        </div>
                        <div v-else class="text-caption">
                          <span>
                            {{ Number(el.qty) }}
                            <span v-if="el.birim">
                              {{
                                $store.state.tanimlar.birim.find((ele) => ele.value === ele.birim)
                                  .text
                              }}
                            </span>
                            <span v-else>Tanımsız</span>
                          </span>
                          <span> - {{ el.total_price | currency }}</span>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                      <v-list-item-action-text>
                        {{ Number(el.qty) }}
                        <span v-if="el.birim">
                          {{
                            $store.state.tanimlar.birim.find((ele) => el.value === ele.birim).text
                          }}
                        </span>
                        <span v-else>Tanımsız</span>
                      </v-list-item-action-text>
                      <v-list-item-action-text>
                        <div class="text-overline white--text">
                          {{ el.total_price | currency }}
                        </div>
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider v-if="item.products.length - 1 > index" :key="`divider-${index}`" />
                </div>
              </v-list>
            </td>
          </template>

          <!-- Sipariş Numarası -->
          <template #[`item.erporderno`]="{ item }">
            <v-chip
              label
              :color="item.erporderno === 'HATA' ? 'error' : 'grey'"
              class="d-flex justify-center text-caption"
            >
              <span
                class="text-caption text-xl-subtitle-2"
                style="letter-spacing: 0.5px; color: azure"
                >{{ item.erporderno }}</span
              >
            </v-chip>
          </template>
          <!-- Sipariş Başlık -->
          <template #[`item.adsoyad`]="{ item }">
            <div
              class="text-truncate"
              :style="
                $vuetify.breakpoint.lgAndDown
                  ? $vuetify.breakpoint.smAndDown
                    ? null
                    : 'max-width: 100px !important'
                  : 'max-width: 350px !important'
              "
            >
              <div class="text-caption text-lg-subtitle-2 white--text">
                {{ item.adsoyad }}
              </div>

              <div class="primary--text" style="font-size: 10px !important; line-height: 1.5">
                {{ item.cari_kod }}
              </div>
            </div>
          </template>
          <!-- Kalem Sayısı -->
          <template #[`item.kalem_sayisi`]="{ item }">
            <v-chip color="#9391a2" outlined class="d-flex justify-center" label>
              <div class="text-capitalize" style="text-align: center; font-size: 11px !important">
                {{ item.products.length }} Adet
              </div>
            </v-chip>
          </template>
          <!-- Sipariş Tarihi -->
          <template #[`item.siparis_tarihi`]="{ item }">
            <v-tooltip color="chip" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip color="" class="d-flex justify-center" label v-bind="attrs" v-on="on">
                  <div
                    class="text-truncate d-flex align-center"
                    style="
                      width: 130px !important;
                      text-align: center;
                      font-size: 11px !important;
                      letter-spacing: 0.5px;
                      color: azure;
                    "
                  >
                    <v-icon color="" small class="mr-2">
                      {{ icons.mdiCalendarClock }}
                    </v-icon>
                    <div class="mr-1">
                      {{ item.siparis_tarihi | moment("DD.MM.YYYY ") }}
                    </div>

                    <span> - {{ item.siparis_tarihi | moment("HH:mm") }}</span>
                  </div>
                </v-chip>
              </template>
              <div>
                {{ item.siparis_tarihi | moment("DD MMMM dddd") }}
              </div>
            </v-tooltip>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-btn
              @click="siparisTekrar(item.id)"
              depressed
              class="text-caption text-capitalize font-weight-bold"
              color="chip"
              >Yeniden Sipariş Ver</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-col>

    <customer-list  v-if="isPlasiyerMngr && $vuetify.breakpoint.xsOnly" />
  </v-row>

  <v-row v-else-if="isPlasiyerMngr && !selectedCustomer">
    <v-col cols="12">
      <customer-alert />
    </v-col>
  </v-row>

  <v-row v-else-if="isBayiSube || (isPlasiyerMngr && selectedCustomer)">
    <v-col cols="12">
      <!-- Üst satır -->
      <v-row>
        <v-col cols="12" md="5">
          <v-card color="grey" rounded="xl" height="100%" class="d-flex align-center pa-6">
            <div class="d-flex">
              <v-avatar class="me-6" color="secondary">
                <v-icon color="white" size="24">
                  {{ icons.mdiPodium }}
                </v-icon>
              </v-avatar>
              <div>
                <div class="text-body-2 font-weight-light">Bu Ayki Toplam</div>
                <div class="text-h6 white--text font-weight-medium pb-5">Sipariş Tutarı</div>
                <v-chip outlined color="primary" label>
                  <span class="text-overline">
                    {{ toplamSiparisTutari | currency }}
                  </span>
                </v-chip>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="7">
          <v-card rounded="xl" color="grey" class="overflow-hidden" height="100%">
            <v-simple-table style="background-color: transparent !important" height="100%">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-body-2 py-2">Borç</td>
                    <td class="text-body-2 py-2">
                      <span class="warning--text"> : {{ balance.BORC | currency }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-body-2 py-2">Alacak</td>
                    <td class="text-body-2 py-2">
                      <span class="success--text"> : {{ balance.ALACAK | currency }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-body-2 py-2">Bakiye</td>
                    <td class="text-body-2 py-2">
                      <span class="error--text"> : {{ balance.BAKIYE | currency }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

      <!-- Alt satır (Bu Ayki Toplam kartının altında) -->
      <v-row align="stretch">
        <v-col cols="12" md="5" class="d-flex align-start">
          <dashboard-unique-products-target
            ref="uniqueTargetRef"
            style="width: 100%"
          />
        </v-col>
        <v-col cols="12" md="7" class="d-flex align-start">
          <dashboard-sales-analysis-report ref="salesReportRef" style="width: 100%" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>


</template>

<script>
// Icons
import { mdiTruck, mdiMinus, mdiOrderNumericAscending, mdiCalendarClock, mdiCameraOff, mdiPodium } from "@mdi/js";
import { computed, onMounted, ref, watch } from "vue-demi";
import { postData, querySearch } from "@utils";
import store from "@/store";
import Vue from "vue";
import CustomerList from "@/components/CustomerList.vue";
import CustomerAlert from "@/components/CustomerAlert.vue";
import DashboardSalesAnalysisReport from "@/views/dashboard/SalesAnalysisReport.vue";
import DashboardUniqueProductsTarget from "@/views/dashboard/UniqueProductsTarget.vue";
import { usePageStore } from "@/stores/pageHeader";
import { useAppStore } from "@/stores/app";
const userData = JSON.parse(localStorage.getItem("userData")) || {};

export default {
  components: {
    CustomerList,
    CustomerAlert,
    DashboardSalesAnalysisReport,
    DashboardUniqueProductsTarget,
  },
  setup() {
    const pageStore = usePageStore();
    const appStore = useAppStore();
    const kurumsalSevkiyat = ref(false);
    const isBayiSube = computed(() => {
      const role = userData?.role;
      return role === "BAYI" || role === "SUBE";
    });
    const isPlasiyerMngr = computed(() => {
      const role = userData?.role;
      return role === "PLSYR" || role === "MNGR" || role === "DIST" || role === "SUPER";
    });
    const selectedCustomer = computed(() => appStore.selectedCustomer);

    const toplamSiparisTutari = ref(0);
    const balance = ref({ BORC: 0, ALACAK: 0, BAKIYE: 0 });

    const uniqueTargetRef = ref(null);
    const salesReportRef = ref(null);

    const tableFetch = async () => {
      try {
        const request = {
          method: "getCustomerDashboardVars",
        };

        const data = await postData(request);
        const { response, error, msg } = data || {};

        if (error) throw new Error(msg || "İşlem başarısız");

        toplamSiparisTutari.value = response?.toplamSiparisTutari ?? 0;
        balance.value = response?.balance ?? { BORC: 0, ALACAK: 0, BAKIYE: 0 };
      } catch (err) {
        Vue.swal({
          title: "Hata",
          text: err?.message || "İşlem başarısız",
          width: "350px",
          icon: "error",
          background: "#FF4C51",
          showCloseButton: false,
          showConfirmButton: true,
          confirmButtonColor: "#cc3d41",
        });
      } finally {
      }
    };

    onMounted(() => {
      if (userData.role === "COMM" || userData.role === "COMUSR") {
        kurumsalSevkiyat.value = true;
      } else {
        kurumsalSevkiyat.value = false;
      }
      if (isBayiSube.value) tableFetch();
    });

    watch(selectedCustomer, (val) => {
      if (isPlasiyerMngr.value && val) tableFetch();
    });

    const siparisHeaders = ref([
      {
        text: "Kalem",
        sortable: false,
        value: "kalem_sayisi",
        width: 80,
        sortable: false,
      },
      {
        text: "Sipariş No",
        sortable: false,
        value: "erporderno",
        width: 130,
      },
      {
        text: "Sipariş Tarihi",
        sortable: false,
        value: "siparis_tarihi",
        width: 130,
      },
      {
        text: "Cari Bilgileri",
        value: "adsoyad",

        sortable: false,
      },

      { text: "", sortable: false, value: "actions", align: "right" },
    ]);
    const siparisItems = ref([]);

    const lastOrder = async () => {
      postData({ method: "getSales" }).then((data) => {
        siparisItems.value = data.response.result;
      });
    };

    const siparisTekrar = (id) => {
      postData({
        method: "repeatOrderById",
        id,
      }).then((response) => {
        if (response.error == 1) {
          Vue.swal({
            title: "Hata",
            text: response.msg,
            width: "350px",
            icon: "error",
            background: "#FF4C51",
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: "#cc3d41",
          });
          return;
        }
        store.dispatch("app-order/fetchBasketItemCount");
        store.commit("app/TOGGLE_BASKET_DRAWER", true);
      });
    };
    const kurumsalSevkiyatYaziAnadolu = computed(() => {
      let result;
      if (userData.role === "COMM") {
        result = "Pazartesi, Çarşamba, Cumartesi";
      } else if (userData.role === "COMUSR") {
        result = "Pazartesi";
      }
      return result;
    });

    const kurumsalSevkiyatYaziAvrupa = computed(() => {
      let result;
      if (userData.role === "COMM") {
        result = "Salı, Perşembe ve Cumartesi";
      } else if (userData.role === "COMUSR") {
        result = "Salı";
      }
      return result;
    });

    return {
      userData,
      pageStore,
      kurumsalSevkiyat,
      isBayiSube,
      isPlasiyerMngr,
      selectedCustomer,
      kurumsalSevkiyatYaziAnadolu,
      kurumsalSevkiyatYaziAvrupa,
      siparisHeaders,
      siparisItems,
      CustomerList,
      toplamSiparisTutari,
      balance,
      uniqueTargetRef,
      salesReportRef,

      siparisTekrar,
      icons: {
        mdiTruck,
        mdiMinus,
        mdiOrderNumericAscending,
        mdiCalendarClock,
        mdiCameraOff,
        mdiPodium,
      },
    };
  },
};
</script>

<style lang="scss">
/* Dark-mode friendly scrollbar (order detail dialog only) */
.order-detail-scroll {
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #6b6586 #2b263f; /* thumb track */
}

.order-detail-scroll::-webkit-scrollbar {
  width: 10px;
}

.order-detail-scroll::-webkit-scrollbar-track {
  background: #2b263f;
}

.order-detail-scroll::-webkit-scrollbar-thumb {
  background: #6b6586;
  border-radius: 10px;
  border: 2px solid #2b263f;
}

.order-detail-scroll::-webkit-scrollbar-thumb:hover {
  background: #8c86a8;
}
</style>
